module.exports = __webpack_public_path__ + "static/media/klaro.3d91ecc7.png";